'use client';

import { Box, HStack, Separator, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import dayjs from 'dayjs';

export default function CopyrightBar() {
  const t = useTranslations();

  return (
    <Box pb={'48px'}>
      <Separator borderColor='rgba(255, 255, 255, 0.2)' />
      <HStack mt={8} justifyContent={'space-between'} color={'white'}>
        <Text color='white'>
          &copy; {dayjs().year()} Mikagroup. {t('all_right_reserved')}.
        </Text>
      </HStack>
    </Box>
  );
}
